export default __webpack_public_path__ + "static/media/g2022-3.455b835e.jpeg";